import { render, staticRenderFns } from "./receivedList.vue?vue&type=template&id=c65a6366&scoped=true&"
import script from "./receivedList.vue?vue&type=script&lang=js&"
export * from "./receivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65a6366",
  null
  
)

export default component.exports